export enum TenantOptionEnum {
  InformationsContactMeetingHomePage = 'InformationsContactMeetingHomePage',
  NoDisponibilitiesMessage = 'NoDisponibilitiesMessage',
  MeetingIAEnabled = 'MeetingIAEnabled'
}
